import { render, staticRenderFns } from "./searchAndTablePart.vue?vue&type=template&id=ffbe4e6a&"
import script from "./searchAndTablePart.vue?vue&type=script&lang=js&"
export * from "./searchAndTablePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports